/* eslint-disable */
export default {
  add: 'Adicionar',
  noCalls: 'Sem chamadas disponíveis',
  activeCall: 'Chamada ativa',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
